import React from 'react'

//Components
import { 
  CloseIcon,
  MediumPriorityStatusIcon,
  ImportantStatusIcon, 
} from 'components/SASIcon'

//Styles
import styles from './Message.module.scss'

interface Props {
  content: React.ReactNode
  onClose?: () => void
  style?: 'error' | 'warning' 
  closeable?: boolean,
}

const Message = ({ content, onClose, style, closeable}:Props) => {

  let msgStyle = "";
  let msgIcon =<></>;
  
  switch(style) {
    case 'error':
      msgStyle = styles.error
      msgIcon = <ImportantStatusIcon />
      break;
    case 'warning':
      msgStyle = styles.warning
      msgIcon = <MediumPriorityStatusIcon />
      break;
    default:
      msgStyle = styles.warning
      break;
  }
  

  return (
    <div className={`${styles.message} ${msgStyle} banner-message`}>
      <span className={styles.icon}>
        {msgIcon}
      </span>
      <span className={styles.content}>
        { content }
      </span>
      {closeable ? <button className={styles.close} onClick={onClose}>
        <CloseIcon />
      </button> : <></>}
    </div>
  )
}

export default Message